import React from 'react';
import { Link } from 'react-router-dom';
import img404 from '../../../assets/admin/img/svgs/img404.svg'; 

function Page404({ homePath = "/" }) {
  return (
    <div className="bg-light d-flex align-items-center justify-content-center min-vh-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-7 text-center">
            <div style={{
              background: 'rgba(255, 255, 255, 0.96)',
              borderRadius: '1.5rem',
              boxShadow: '0 10px 36px rgba(40,40,40,0.1)',
              padding: '48px 28px',
              position: 'relative'
            }}>
              <img
                src={img404}
                alt="404"
                style={{
                  width: '180px',
                  marginBottom: '18px',
                  animation: 'bounce 1.8s infinite, fade-in 1.6s 1',
                  display: 'inline-block'
                }}
              />
              <h1 className="display-4 fw-bold mb-3" style={{color: "#ec008c"}}>
                404 - Page Not Found!
              </h1>
              <p className="lead mb-4" style={{color: "#444", fontSize:'1.19rem'}}>
                Oops! The page you’re looking for does not exist.<br/>
                Maybe you mistyped the address or the page has moved.
              </p>
              <Link
                className="btn btn-lg btn-primary shadow fw-bold px-4"
                to={homePath}
                style={{
                  background: "linear-gradient(135deg, #fc6767, #ec008c)",
                  border: "none",
                }}
              >
                Back to Home
              </Link>
              <style>{`
                @keyframes bounce {
                  0%, 100% { transform: translateY(0);}
                  40% { transform: translateY(-24px);}
                  60% { transform: translateY(-12px);}
                }
                @keyframes fade-in {
                  from { opacity: 0; }
                  to { opacity: 1; }
                }
              `}</style>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page404;
